export default {"src":"/_next/static/media/tern.5ae4a099.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};